import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'footer-specs',
  templateUrl: './footer-specs.component.html',
  styleUrls: ['./footer-specs.component.sass']
})
export class FooterSpecsComponent implements OnInit {
  public component = window.location.protocol + '//' + window.location.host + '/design-specs-measure/footer/';
  constructor() { }

  ngOnInit(): void {
  }

  clickEvent(route) {
    if(route == 'light') {
      window.open(this.component, "_blank");
    }
  }
}
